import React, {Component} from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../css/bg.css';
import img1 from '../assets/lb_01 (1).jpg';
import img2 from '../assets/lb_02 (1).jpg';
import img3 from '../assets/lb_03 (3).jpg';
import img4 from '../assets/lb_04 (1).jpg';
import img5 from '../assets/lb_05 (1).jpg';
class Bg extends Component {

    render() {
        const settings = {
            dots: false,
            arrows: false,
            infinite: true,
            speed: 2000,
            autoplay: true,
            fade: true,
            autoplaySpeed: 6000,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        return (
            <div className="i_carousel">
                <div className="bg-mask"/>
                <Slider {...settings}>
                    <div className="c_img c_img1"><img src={img3}></img></div>
                    <div className="c_img c_img2"><img src={img4}></img></div>
                    <div className="c_img c_img3"><img src={img5}></img></div>
                    <div className="c_img c_img5"><img src={img1}></img></div>
                    <div className="c_img c_img6"><img src={img2}></img></div>
                </Slider>
            </div>
        );
    }
}

export default Bg;



// WEBPACK FOOTER //
// ./src/components/Bg.jsx